<template>
  <v-dialog width="480" v-model="showModal">
    <modal-card title="Smile!" padding @close="showModal = false">
      <div class="video-wrapper selfie-feed"></div>

      <template v-slot:actions>
        <v-btn color="appMain" @click="captureImage" :disabled="!videoAttached">
          Take Selfie
        </v-btn>
      </template>
    </modal-card>
  </v-dialog>
</template>

<script>
import { eventBus } from '@/lib/events';

export default {
  name: 'TakeSelfieModal',
  props: {
    value: Boolean,
  },
  data() {
    return {
      captureImageTimeout: null,
      videoAttached: null,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    showModal: {
      immediate: true,
      handler(show) {
        if (!show) {
          this.removeVideo();
        } else {
          this.addVideoTrack();
        }
      },
    },
  },
  methods: {
    async addVideoTrack() {
      await this.$nextTick();

      navigator.mediaDevices
        .getUserMedia({
          video: { facingMode: 'environment', width: 640, height: 480 },
        })
        .then((stream) => {
          this.attachVideo(stream);
        })
        .catch((err) => {
          eventBus.trigger('showRoomInfoDialog', {
            mediaError: err,
          });
        });
    },

    attachVideo(stream) {
      const videoWrap = document.querySelector('.selfie-feed');
      const video = document.createElement('video');
      videoWrap.appendChild(video);

      video.srcObject = stream;
      video.onloadedmetadata = function () {
        video.play();
      };

      this.videoAttached = true;
    },

    removeVideo() {
      const video = document.querySelector('.selfie-feed video');
      if (!video) return;
      video.remove();
      this.videoAttached = false;
    },

    imgValid(dataUrl) {
      if (dataUrl === 'data:,') {
        clearTimeout(this.captureImageTimeout);
        this.captureImageTimeout = setTimeout(() => {
          this.captureImage();
        }, 1000);
        return false;
      }
      return true;
    },

    captureImage() {
      const video = document.querySelector('.selfie-feed video');
      const scale = 0.75;

      if (!video) {
        return false;
      }

      this.imageProcessing = true;
      let canvas = document.createElement('canvas');
      canvas.height = video.videoHeight * scale;
      canvas.width = video.videoWidth * scale;

      const ctx = canvas.getContext('2d');

      // flip image horizontally
      // ctx.scale(-1, 1);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const dataUrlImg = canvas.toDataURL();

      if (this.imgValid(dataUrlImg)) {
        this.$emit('save', dataUrlImg);
        this.showModal = false;
      } else {
        console.log('image invalid');
      }
    },
  },
};
</script>

<style>
.selfie-feed video {
  transform: scale(-1, 1);
}
</style>
